/**
 * @generated SignedSource<<058ee0e27b744503f944bb42dd7db033>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductHeader_ProductDetails$data = {
  readonly imageUrl: string | null;
  readonly name: string | null;
  readonly partNumber: string | null;
  readonly " $fragmentType": "ProductHeader_ProductDetails";
};
export type ProductHeader_ProductDetails$key = {
  readonly " $data"?: ProductHeader_ProductDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductHeader_ProductDetails">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductHeader_ProductDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "ProductDetails",
  "abstractKey": "__isProductDetails"
};

(node as any).hash = "1b0e640598cc34cafc33d9ecac8d98c1";

export default node;
